'use strict';

const cookieNameMaps = 'af-maps-consent';

const checkboxKarta = document.getElementById('karta-medgivande');

checkboxKarta.addEventListener('change',
    (event) => {
        if (event.currentTarget.checked) {
            af.setCookie(cookieNameMaps, 'y', 7, true);
        } else {
            af.deleteCookie(cookieNameMaps);
        }
    });

const cookieNameRundvandring = 'af-rundvandring-consent';

const checkboxRundvandring = document.getElementById('rundvandring-medgivande');

checkboxRundvandring.addEventListener('change',
    (event) => {
        if (event.currentTarget.checked) {
            af.setCookie(cookieNameRundvandring, 'y', 7, true);
        } else {
            af.deleteCookie(cookieNameRundvandring);
        }
    });

const checkboxCookieBanner = document.getElementById('cookies-medgivande');

checkboxCookieBanner.addEventListener('change',
    (event) => {
        if (event.currentTarget.checked) {
            cookieConsent.setConsentCookie(cookieConsent.yes);
        } else {
            cookieConsent.setConsentCookie(cookieConsent.no);
            cookieConsent.deleteTrackingCookies();
        }
    });